import { TIconNames } from "src/shared/types/iconNames";
import { TransactionBackendService } from "./types";

const BACKEND_SERVICE_TO_ICON: Record<
  Exclude<TransactionBackendService, null>,
  TIconNames | undefined
> = {
  google: "google_ads_transactions",
  yandex: "yandex_direct_transactions",
  tiktok: "tiktok_transactions",
  fb: "meta_transactions",
  telegram: "telegram_transactions",
  vkads: "vk_ads_transactions",
  undefined: "empty_wallet_transactions",
};

export function mapBackendServiceToIcon(
  service?: TransactionBackendService,
): TIconNames | undefined {
  if (!service) return "empty_wallet_transactions";

  return BACKEND_SERVICE_TO_ICON[service] ?? "empty_wallet_transactions";
}
